/* eslint-disable react/no-danger */
import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { ThemeGlobal } from '@styles/theme-global';
import {
  selectPortfolio,
  selectMenuCollectionSelected,
  selectPortfolioMode,
  selectHeaderStyle,
} from './selectors';
import { I_MenuPortfolio } from './typesIndex';
import { actions } from './slice';
import { HomeWrapper } from './styled';
import HeaderStyle4 from './components/Header.Style4';

const Header = dynamic(() => import('./components/Header'));
const Footer = dynamic(() => import('./components/Footer'));
const Collection = dynamic(() => import('./components/Collection'));

function Home() {
  const router = useRouter();
  const dispatch = useDispatch();

  const mode = useSelector(selectPortfolioMode);
  const portfolio = useSelector(selectPortfolio);
  const headerStyle = useSelector(selectHeaderStyle);
  const menuCollectionSelected = useSelector(selectMenuCollectionSelected);

  const { menu, user, slug, hideSlug, primaryColor, secondaryColor } =
    portfolio || {};

  const onChangeCollectionPortfolio = useCallback(
    (type: I_MenuPortfolio['type'], value: string) => {
      if (value)
        switch (type) {
          case 'collection':
            dispatch(actions.onChangeMenuCollectionSelected(value));
            break;
          case 'link':
            window.open(value, '_blank');
            break;
          default:
            break;
        }
    },
    [dispatch],
  );

  useEffect(() => {
    if (menuCollectionSelected && menuCollectionSelected !== 'Panoee_Default')
      router.push(
        `${portfolio.slug}?collection=${menuCollectionSelected}`,
        undefined,
        {
          shallow: true,
        },
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuCollectionSelected]);

  return (
    <>
      <HomeWrapper className={mode === 'dark' ? 'dark-mode' : 'light-mode'}>
        <Header
          portfolio={portfolio}
          menuCollectionSelected={menuCollectionSelected}
          onChangeCollectionPortfolio={onChangeCollectionPortfolio}
        />
        <Collection
          childrenHeaderUser={
            headerStyle === '4' ? (
              <HeaderStyle4.User
                isHideSlug={hideSlug}
                slug={slug}
                user={user}
              />
            ) : undefined
          }
          childrenHeaderMenu={
            headerStyle === '4' ? (
              <HeaderStyle4.Menu
                menu={menu}
                menuCollectionSelected={menuCollectionSelected}
                onChangeCollectionPortfolio={onChangeCollectionPortfolio}
              />
            ) : undefined
          }
        />
        <Footer slug={slug} user={user} isHideSlug={hideSlug} />
      </HomeWrapper>
      <ThemeGlobal
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
      />
    </>
  );
}

export default memo(Home);
